"use strict";
exports.__esModule = true;
exports.assignFromAccountRaw = exports.assignToAccountRaw = exports.fromCardanoResourceRaw = exports.toCardanoResourceRaw = void 0;
var bignumber_js_1 = require("bignumber.js");
function toTokenRaw(_a) {
    var assetName = _a.assetName, policyId = _a.policyId, amount = _a.amount;
    return {
        assetName: assetName,
        policyId: policyId,
        amount: amount.toString()
    };
}
function fromTokenRaw(_a) {
    var assetName = _a.assetName, policyId = _a.policyId, amount = _a.amount;
    return {
        assetName: assetName,
        policyId: policyId,
        amount: new bignumber_js_1.BigNumber(amount)
    };
}
function toBipPathRaw(_a) {
    var purpose = _a.purpose, coin = _a.coin, account = _a.account, chain = _a.chain, index = _a.index;
    return {
        purpose: purpose,
        coin: coin,
        account: account,
        chain: chain,
        index: index
    };
}
function fromBipPathRaw(_a) {
    var purpose = _a.purpose, coin = _a.coin, account = _a.account, chain = _a.chain, index = _a.index;
    return {
        purpose: purpose,
        coin: coin,
        account: account,
        chain: chain,
        index: index
    };
}
function toPaymentCredentialRaw(r) {
    return {
        isUsed: r.isUsed,
        key: r.key,
        path: toBipPathRaw(r.path)
    };
}
function fromPaymentCredentialRaw(r) {
    return {
        isUsed: r.isUsed,
        key: r.key,
        path: fromBipPathRaw(r.path)
    };
}
function toCardanoOutputRaw(_a) {
    var hash = _a.hash, index = _a.index, address = _a.address, amount = _a.amount, tokens = _a.tokens, paymentCredential = _a.paymentCredential;
    return {
        hash: hash,
        index: index,
        address: address,
        amount: amount.toString(),
        tokens: tokens.map(toTokenRaw),
        paymentCredential: paymentCredential
    };
}
function fromCardanoOutputRaw(_a) {
    var hash = _a.hash, index = _a.index, address = _a.address, amount = _a.amount, tokens = _a.tokens, paymentCredential = _a.paymentCredential;
    return {
        hash: hash,
        index: index,
        address: address,
        amount: new bignumber_js_1.BigNumber(amount),
        tokens: tokens.map(fromTokenRaw),
        paymentCredential: paymentCredential
    };
}
function toProtocolParamsRaw(_a) {
    var minFeeA = _a.minFeeA, minFeeB = _a.minFeeB, stakeKeyDeposit = _a.stakeKeyDeposit, lovelacePerUtxoWord = _a.lovelacePerUtxoWord, collateralPercent = _a.collateralPercent, priceSteps = _a.priceSteps, priceMem = _a.priceMem, languageView = _a.languageView;
    return {
        minFeeA: minFeeA,
        minFeeB: minFeeB,
        stakeKeyDeposit: stakeKeyDeposit,
        lovelacePerUtxoWord: lovelacePerUtxoWord,
        collateralPercent: collateralPercent,
        priceSteps: priceSteps,
        priceMem: priceMem,
        languageView: languageView
    };
}
function fromProtocolParamsRaw(_a) {
    var minFeeA = _a.minFeeA, minFeeB = _a.minFeeB, stakeKeyDeposit = _a.stakeKeyDeposit, lovelacePerUtxoWord = _a.lovelacePerUtxoWord, collateralPercent = _a.collateralPercent, priceSteps = _a.priceSteps, priceMem = _a.priceMem, languageView = _a.languageView;
    return {
        minFeeA: minFeeA,
        minFeeB: minFeeB,
        stakeKeyDeposit: stakeKeyDeposit,
        lovelacePerUtxoWord: lovelacePerUtxoWord,
        collateralPercent: collateralPercent,
        priceSteps: priceSteps,
        priceMem: priceMem,
        languageView: languageView
    };
}
function toCardanoResourceRaw(r) {
    return {
        internalCredentials: r.internalCredentials.map(toPaymentCredentialRaw),
        externalCredentials: r.externalCredentials.map(toPaymentCredentialRaw),
        utxos: r.utxos.map(toCardanoOutputRaw),
        protocolParams: toProtocolParamsRaw(r.protocolParams)
    };
}
exports.toCardanoResourceRaw = toCardanoResourceRaw;
function fromCardanoResourceRaw(r) {
    return {
        internalCredentials: r.internalCredentials.map(fromPaymentCredentialRaw),
        externalCredentials: r.externalCredentials.map(fromPaymentCredentialRaw),
        utxos: r.utxos.map(fromCardanoOutputRaw),
        protocolParams: fromProtocolParamsRaw(r.protocolParams)
    };
}
exports.fromCardanoResourceRaw = fromCardanoResourceRaw;
function assignToAccountRaw(account, accountRaw) {
    var cardanoAccount = account;
    if (cardanoAccount.cardanoResources) {
        accountRaw.cardanoResources = toCardanoResourceRaw(cardanoAccount.cardanoResources);
    }
}
exports.assignToAccountRaw = assignToAccountRaw;
function assignFromAccountRaw(accountRaw, account) {
    var cardanoResourcesRaw = accountRaw
        .cardanoResources;
    if (cardanoResourcesRaw)
        account.cardanoResources =
            fromCardanoResourceRaw(cardanoResourcesRaw);
}
exports.assignFromAccountRaw = assignFromAccountRaw;
//# sourceMappingURL=serialization.js.map